import { createApp } from 'vue'
import App from './App.vue'

// Global brand system (SCSS)
import './assets/scss/main.scss'

// Material Design Icons - Import after SCSS to ensure it's not overridden
import '@mdi/font/css/materialdesignicons.css'

// Vuetify
import vuetify from './plugins/vuetify'

// Pinia
import { createPinia } from 'pinia'

// Router
import router, { setupRouterGuards } from './router'

// Toast Plugin
import toastPlugin from './plugins/toast'

// Application identification console log
console.log(`
🏭 BANJINO'S MANUFACTURING INTELLIGENCE ADMIN PANEL
📍 Domain: app.banjinos.com
📂 Frontend: /frontend (admin)
🎯 Purpose: Manufacturing intelligence, materials, recipes, batches, optimization
🚀 Starting application...
`);

const pinia = createPinia()
const app = createApp(App)

// CRITICAL: Set up Pinia BEFORE router to ensure stores are available
app.use(pinia)
app.use(vuetify)
app.use(router)
app.use(toastPlugin)

// Mount the app first to ensure all stores are available
app.mount('#app')

// Set up router guards after app is fully mounted and stores are available
setupRouterGuards()
